export const premiereColors = {
    sysRed: '#FC5466',
};
